export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8311.09a411b1.jpg";